import { IElementBase } from "core-integration/src/store/elements/types";

export const isDecimalStat = (stat: any): boolean => {
  const decimalStats: Array<keyof IElementBase> = [
    "form",
    "value_form",
    "value_season",
  ];
  return decimalStats.indexOf(stat) > -1;
};

export const integerToDecimal = (int: number, divisor: number) =>
  (int / divisor).toFixed(1);
